import React from "react";
import { EnumLoggingScreenNames } from "libs/logging/types/loggingTypes";
export default class SMCBannerUtil {
  public static isCountryEnabled(country: string) {
    const SMCAllowedCountries =
      process.env.NEXT_PUBLIC_SMC_CAMPAIGN_ALLOWED_COUNTRIES || "";
    return SMCAllowedCountries.split("|").includes(country);
  }
  public static getMPUBanner(
    country: string,
    screenName: EnumLoggingScreenNames
  ) {
    if (!SMCBannerUtil.isCountryEnabled(country)) return undefined;
    const allowedScreens = [
      EnumLoggingScreenNames.HOME,
      EnumLoggingScreenNames.LISTING_VIEW,
      EnumLoggingScreenNames.SEARCH,
    ];
    const condition = allowedScreens.includes(screenName);
    if (!condition) return undefined;

    return {
      head: (
        <script
          dangerouslySetInnerHTML={{
            __html: ` window.googletag = window.googletag || {cmd: []};
                    googletag.cmd.push(function() {
                    googletag.defineSlot('/22729315574,1082751/OpenSooq/OpenSooq_Mobile_MPU', [300, 250], 'div-gpt-ad-1702471340982-0').addService(googletag.pubads());
                    googletag.pubads().enableSingleRequest();
                    googletag.enableServices();
                    });
                    `,
          }}
        />
      ),
      body: (
        <div
          id="div-gpt-ad-1702471340982-0"
          style={{ minWidth: "300px", minHeight: "250px" }}
          className={"mb-32 center"}
        >
          <script
            dangerouslySetInnerHTML={{
              __html: `googletag.cmd.push(function() { googletag.display('div-gpt-ad-1702471340982-0'); });`,
            }}
          />
        </div>
      ),
    };
  }

  public static getLBBanner(
    country: string,
    screenName: EnumLoggingScreenNames
  ) {
    if (!SMCBannerUtil.isCountryEnabled(country)) return undefined;
    const allowedScreens = [EnumLoggingScreenNames.LISTING_VIEW];
    const condition = allowedScreens.includes(screenName);
    if (!condition) return undefined;

    return {
      head: (
        <script
          dangerouslySetInnerHTML={{
            __html: `window.googletag = window.googletag || {cmd: []};
                googletag.cmd.push(function() {
                googletag.defineSlot('/22729315574,1082751/OpenSooq/OpenSooq_Mobile_LB', [[320, 48], [320, 50]], 'div-gpt-ad-1702470293457-0').addService(googletag.pubads());
                googletag.pubads().enableSingleRequest();
                googletag.enableServices();
                });`,
          }}
        />
      ),
      body: (
        <div
          id="div-gpt-ad-1702470293457-0"
          style={{ minHeight: "48px", minWidth: "320px" }}
          className="center"
        >
          <script
            dangerouslySetInnerHTML={{
              __html: `googletag.cmd.push(function() { googletag.display('div-gpt-ad-1702470293457-0'); });`,
            }}
          />
        </div>
      ),
    };
  }
}
